<!-- <div class="">
    <div class="page-content">
        <h2 class="so-heading1">Incoming Payment</h2>
        <div class="mt-4 pt-1"> -->



<!-- Start of card UI -->
<div class="ip-section">
    <div class="page-content">
        <h2 class="heading7">{{ this.getFormSubTitle=='Incoming Payment'?('Language.IncomingPaymentText' |
            translate):('Language.OutgoingPaymentText' | translate) }}</h2>
        <fieldset [disabled]="(getFormMode == 0 && !canAdd) || (getFormMode == 1 && !canEdit)" class="view-mode-fieldset" style="border: none; padding: 0; margin: 0;">


        <!-- <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"> -->
        <!-- <mat-tab-group mat-stretch-tabs="false" class="opportunitytabs" [selectedIndex]="this.selectedTabIndex"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab
                label="{{ this.getFormSubTitle =='Incoming Payment'?('Language.IncomingPaymentText' | translate):('Language.OutgoingPaymentText' | translate) }}"> -->
        <!-- <mat-tab label="Customer"> -->
        <mat-card>
            <mat-card-content>
                <h3 class="heading2">{{ this.getFormSubTitle =='Incoming Payment'?('Language.IncomingPaymentText' |
                    translate):('Language.OutgoingPaymentText' | translate) }}</h3>
                <div class="entry-forms w-55">
                    <!-- <div class="row"> -->
                    <!-- <div class="page-content">
                    <div class="entry-forms w-55"> -->
                    <div class="row mt-3">
                        <!-- <div class="col-md-6 pe-5"> -->
                        <!-- <div class="row"> -->
                        <div class="col-md-6">
                            <label class="f-label">{{'Language.BranchNameText' | translate }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="branchName" (click)="onOpenDropDown('BPLName',0)"
                                    readonly [(ngModel)]="this.getEntryFormDataSource.branchName"
                                    (input)="btnEvent($event);" [disabled]="this.getFormDisable" />
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                    (click)="onOpenDropDown('BPLName',0)" [class.disabled-icon]="getFormDisable">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label">{{'Language.SeriesText' | translate}}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="seriesName" (click)="onOpenDropDown('Series',0)"
                                    readonly [(ngModel)]="this.getEntryFormDataSource.seriesName"
                                    (input)="btnEvent($event);" [disabled]="this.getFormDisable" />
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                    (click)="onOpenDropDown('Series',0)" [class.disabled-icon]="getFormDisable">
                            </mat-form-field>
                        </div>

                        <div class="col-md-6">
                            <label class="f-label">{{'Language.DocumentType' | translate}}</label>
                            <div class="ps-5 ms-5">
                                <div>
                                    <label>
                                        <input type="radio" name="docType" value="C"
                                            [(ngModel)]="this.getEntryFormDataSource.docType"
                                            [disabled]="this.getFormDisable" (change)="onDocTypeChange()"> Customer
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input type="radio" name="docType" value="S"
                                            [(ngModel)]="this.getEntryFormDataSource.docType"
                                            [disabled]="this.getFormDisable" (change)="onDocTypeChange()"> Vendor
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input type="radio" name="docType" value="A"
                                            [(ngModel)]="this.getEntryFormDataSource.docType"
                                            [disabled]="this.getFormDisable" (change)="onDocTypeChange()"> Account
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label">{{'Language.NumberText' | translate}}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput [(ngModel)]="this.getEntryFormDataSource.docNum"
                                    [disabled]="this.getFormDisable">
                            </mat-form-field>
                        </div>

                        <!-- <div class="col-md-6">
                                        <label class="f-label">{{'Language.OffsetAccount' | translate}}</label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <input type="text" matInput (click)="onOpenDropDown('offsetaccount',0)"
                                                [(ngModel)]="this.getEntryFormDataSource.controlAccountName"
                                                [disabled]="this.getFormDisable">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">

                                        </mat-form-field>
                                    </div>  -->

                        <div class="col-md-6"
                            *ngIf="this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S'">
                            <label class="f-label">{{'Language.Customer/VendorCodeText' | translate
                                }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="cardCode" (click)="onOpenDropDown('BPCode',0)"
                                    readonly [(ngModel)]="this.getEntryFormDataSource.cardCode"
                                    (input)="btnEvent($event);getInvoice();"
                                    [disabled]="this.getFormDisable || cutomerOrVendorDisabled" (change)="getInvoice()">
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                    (click)="onOpenDropDown('BPCode',0)"
                                    [class.disabled-icon]="getFormDisable || cutomerOrVendorDisabled">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"
                            *ngIf="this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S'">
                            <label class="f-label">{{'Language.Customer/VendorNameText' | translate
                                }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput readonly name="cardName"
                                    [disabled]="this.getFormDisable || cutomerOrVendorDisabled"
                                    [(ngModel)]="this.getEntryFormDataSource.cardName"
                                    (ngModelChange)="btnEvent($event)">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"
                            *ngIf="(this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S')&& getFormSubTitle=='Incoming Payment'">
                            <label class="f-label">{{'Language.BillToText' |
                                translate }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="shipToCode" readonly [disabled]="this.getFormDisable"
                                    (click)="onOpenDropDown('BillTo',0)"
                                    [(ngModel)]="this.getEntryFormDataSource.billToCode"
                                    (ngModelChange)="btnEvent($event)">
                                <img src="./assets/images/cfl.svg" matSuffix alt=""
                                    [class.disabled-icon]="getFormDisable" class="me-2"
                                    (click)="onOpenDropDown('BillTo',0)">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"
                            *ngIf="(this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S' )&& getFormSubTitle=='Outgoing Payment'">
                            <label class="f-label">{{'Language.PayToText' |
                                translate }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="shipToCode" [disabled]="this.getFormDisable"
                                    (click)="onOpenDropDown('BillTo',0)" readonly
                                    [(ngModel)]="this.getEntryFormDataSource.payToCode"
                                    (ngModelChange)="btnEvent($event)">
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                    (click)="onOpenDropDown('BillTo',0)" [class.disabled-icon]="getFormDisable">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"
                            *ngIf="this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S'">
                            <label class="f-label"><span class="required">*</span>{{'Language.AddressText' |
                                translate }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="address"
                                    [(ngModel)]="this.getEntryFormDataSource.address" readonly
                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"
                            *ngIf="this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S'">
                            <label class="f-label">
                                {{'Language.ContactPersonText' | translate}}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput readonly (click)="onOpenDropDown('ContactPerson',0)"
                                    [(ngModel)]="this.getEntryFormDataSource.contactPersonName"
                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                    (click)="onOpenDropDown('ContactPerson',0)" [class.disabled-icon]="getFormDisable">
                            </mat-form-field>
                        </div>

                        <!-- </div>
                            </div> -->
                        <!-- <div class="col-md-6 pe-5">
                                <div class="row"> -->


                        <div class="col-md-6">
                            <label class="f-label"> {{'Language.PostingDateText' | translate}} </label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput [matDatepicker]="picker" (click)="picker.open()"
                                    placeholder="dd/mm/yyyy" [(ngModel)]="this.getEntryFormDataSource.docDate"
                                    [disabled]="this.getFormDisable">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label"> {{'Language.DueDateText' | translate}} </label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput [matDatepicker]="picker1" (click)="picker1.open()"
                                    placeholder="dd/mm/yyyy" [(ngModel)]="this.getEntryFormDataSource.docDueDate"
                                    [disabled]="this.getFormDisable">
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label"> {{'Language.DocumentDateText' | translate}} </label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput [matDatepicker]="picker2" (click)="picker2.open()"
                                    placeholder="dd/mm/yyyy" [disabled]="this.getFormDisable"
                                    [(ngModel)]="this.getEntryFormDataSource.taxDate">
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-md-6 d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <label class="f-label d-flex"> {{'Language.DocumentTotal' | translate}}
                                            </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput [disabled]="this.getFormDisable"
                                                    [(ngModel)]="this.getEntryFormDataSource.docTotal">
                                            </mat-form-field>
                                        </div>
                                        <button mat-icon-button (click)="openDialog1()" class="ml-2">
                                            <mat-icon>payment</mat-icon>
                                        </button>
                                    </div> -->
                        <div class="col-md-6">
                            <label class="f-label">{{'Language.TransactionNumber' | translate}}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput
                                    [disabled]="!this.getFormDisable || this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'"
                                    [(ngModel)]="this.getEntryFormDataSource.transactionNo" (click)="journalEntry()">
                                <img src="../../../../assets/images/transaction.svg" matSuffix alt=""
                                    (click)="journalEntry()" class="me-2"
                                    [class.disabled-icon]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label">{{'Language.ReferenceNumberText' | translate}}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput [(ngModel)]="this.getEntryFormDataSource.counterReference"
                                    [disabled]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label mt-2">{{'Language.RemarksText' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
                                <textarea matInput rows="4" placeholder="Write your remarks"
                                    [(ngModel)]="this.getEntryFormDataSource.remarks"
                                    [disabled]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="f-label mt-2"> {{'Language.JournalRemarks' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
                                <textarea matInput rows="4" placeholder="Write your journal remarks"
                                    [(ngModel)]="this.getEntryFormDataSource.journalRemarks"
                                    [disabled]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'"></textarea>
                            </mat-form-field>
                        </div>
                        <!-- </div> -->
                        <!-- </div> -->
                    </div>


                </div>
                <!-- 
                </div> -->
            </mat-card-content>
        </mat-card>

        <!-- </mat-tab> -->
        <mat-card class="mt-4">
            <mat-card-content>
                <mat-tab-group style="min-height:auto;" mat-stretch-tabs="false" class="opportunitytabs"
                    [selectedIndex]="this.selectedTabIndex" (selectedTabChange)="onTabChange($event)">
                    <mat-tab label="Contents"
                        *ngIf="this.getEntryFormDataSource.docType=='C' || this.getEntryFormDataSource.docType=='S'">

                        <!-- 
                <div class="page-content"> -->
                        <div class="entry-forms incoming-payment mt-3">
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <table mat-table [dataSource]="this.getEntryFormDataSource.paymentInvoices">

                                        <!-- ============ SELECT ============ -->
                                        <ng-container matColumnDef="select" sticky>
                                            <th mat-header-cell *matHeaderCellDef class="text-center"> Select </th>
                                            <td mat-cell *matCellDef="let row" class="text-center p-0">
                                                <mat-checkbox value="element" [checked]="row.isSelected"
                                                    (change)="onChangeCheckBox($event,row)"
                                                    [disabled]="this.getFormDisable"></mat-checkbox>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Branch Column ============ -->
                                        <ng-container matColumnDef="branch">
                                            <th mat-header-cell *matHeaderCellDef> Branch </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput
                                                        name="{{this.getEntryFormDataSource.branchName}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.branchName"
                                                        value="{{this.getEntryFormDataSource.branchName}}"
                                                        (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{this.getEntryFormDataSource.branchName}}"
                                                        matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Document No. Column ============ -->
                                        <ng-container matColumnDef="documentNo">
                                            <th mat-header-cell *matHeaderCellDef>Document No.</th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="{{row.docNum}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.docNum"
                                                        value="{{row.docNum}}" (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.docNum}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Customer Ref No. Column ============ -->
                                        <ng-container matColumnDef="customerRefNo">
                                            <th mat-header-cell *matHeaderCellDef> Customer/Vendor Ref No.
                                            </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="{{row.numAtCard}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.numAtCard"
                                                        value="{{row.numAtCard}}" (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.numAtCard}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="documentType">
                                            <th mat-header-cell *matHeaderCellDef> Document Type </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="{{row.docTypeName}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.docTypeName"
                                                        value="{{row.docTypeName}}" (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.docTypeName}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Document Date Column ============ -->
                                        <ng-container matColumnDef="documentDate">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.DocumentDateText' |
                                                translate}} </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="{{row.docDate}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.docDate"
                                                        (ngModelChange)="btnEvent($event)" matTooltip="{{row.docDate}}"
                                                        matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Due Date Column ============ -->
                                        <ng-container matColumnDef="dueDate">
                                            <th mat-header-cell *matHeaderCellDef>{{'Language.DueDateText' | translate}}
                                            </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="{{row.dueDate}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.dueDate"
                                                        value="{{row.dueDate | date: 'dd-MM-yy'}}"
                                                        (ngModelChange)="btnEvent($event)" matTooltip="{{row.dueDate}}"
                                                        matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Overdue Days Column ============ -->
                                        <ng-container matColumnDef="overdueDays">
                                            <th mat-header-cell *matHeaderCellDef> Overdue Days </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput [(ngModel)]="row.overDueDays" readonly
                                                        [disabled]="this.getFormDisable"
                                                        (ngModelChange)="btnEvent($event)" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Total Column ============ -->
                                        <ng-container matColumnDef="total">
                                            <th mat-header-cell *matHeaderCellDef> Total </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="number" matInput name="{{row.docTotal}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.docTotal"
                                                        value="{{row.docTotal}}" (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.docTotal}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="balDue">
                                            <th mat-header-cell *matHeaderCellDef> Balance Due </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="number" matInput name="{{row.dueAmount}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.dueAmount"
                                                        value="{{row.dueAmount}}" (ngModelChange)="btnEvent($event);"
                                                        matTooltip="{{row.dueAmount}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Cash Discount % Column ============ -->
                                        <ng-container matColumnDef="cashDiscount">
                                            <th mat-header-cell *matHeaderCellDef> Cash Discount % </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="number" matInput name="{{row.discountPercent}}"
                                                        [disabled]="this.getFormDisable"
                                                        [(ngModel)]="row.discountPercent"
                                                        value="{{row.discountPercent}}" (change)="calculateDiscount(i)"
                                                        (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.discountPercent}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Discount Amount Column ============ -->
                                        <ng-container matColumnDef="discountAmount">
                                            <th mat-header-cell *matHeaderCellDef> Discount Amount </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="number" matInput name="{{row.totalDiscount}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.totalDiscount"
                                                        value="{{row.totalDiscount}}" (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.totalDiscount}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Total Payment Column ============ -->
                                        <ng-container matColumnDef="totalPayment">
                                            <th mat-header-cell *matHeaderCellDef> Total Payment </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="number" matInput name="{{row.sumApplied}}"
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.sumApplied"
                                                        value="{{row.sumApplied}}" (ngModelChange)="btnEvent($event);"
                                                        (change)="changediscount(i);" matTooltip="{{row.sumApplied}}"
                                                        matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="docRemarks">
                                            <th mat-header-cell *matHeaderCellDef> Document Remarks </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput name="{{row.remarks}}" readonly
                                                        [disabled]="this.getFormDisable" [(ngModel)]="row.remarks"
                                                        value="{{row.remarks}}" (ngModelChange)="btnEvent($event)"
                                                        matTooltip="{{row.remarks}}" matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="deleteRow">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.ActionText' | translate
                                                }}</th>
                                            <td mat-cell *matCellDef="let element ; let i=index">
                                                <i-feather *ngIf="this.getFormMode==0 && canAdd" class="t-icon popinter pointer"
                                                    name="trash-2" (click)="deleteRow(i)"> </i-feather>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns,sticky: true"></tr>
                                        <tr mat-row class="tablecard" *matRowDef="let row; columns: displayedColumns;">
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <!-- <div class="col-md-12 mt-3" *ngIf="this.getFormMode==0">
                            <button mat-stroked-button color="primary" (click)="addRow()">{{'Language.AddNewItemText' |
                                translate }}</button>
                        </div> -->

                        </div>
                        <!-- </div> -->


                    </mat-tab>


                    <mat-tab label="Account" *ngIf="this.getEntryFormDataSource.docType=='A'">



                        <div class="entry-forms  incoming-payment mt-3">
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="tabledesign" style="height:400px">
                                        <table mat-table [dataSource]="this.getEntryFormDataSource.paymentAccounts">



                                            <!-- ============ Account Column ============ -->
                                            <ng-container matColumnDef="account">
                                                <th mat-header-cell *matHeaderCellDef> Account </th>
                                                <td mat-cell *matCellDef="let row;let i=index">
                                                    <mat-form-field class="w-160 field-bottom-0 mt-3"
                                                        appearance="outline">
                                                        <input type="text" matInput name="{{row.accountCode}}" readonly
                                                            [disabled]="this.getFormDisable"
                                                            [(ngModel)]="row.accountName" value="{{row.accountName}}"
                                                            (click)="onOpenDropDown(3,i)"
                                                            (ngModelChange)="btnEvent($event)"
                                                            matTooltip="{{row.accountName}}" matTooltipPosition="below">
                                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                                            [class.disabled-icon]="getFormDisable"
                                                            (click)="onOpenDropDown(3,i)">
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>

                                            <!-- ============ Document No. Column ============ -->
                                            <ng-container matColumnDef="docRemarks">
                                                <th mat-header-cell *matHeaderCellDef>Document Remarks</th>
                                                <td mat-cell *matCellDef="let row;let i=index">
                                                    <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                        <input type="text" matInput name="{{row.remarks}}"
                                                            [disabled]="this.getFormDisable" [(ngModel)]="row.remarks"
                                                            value="{{row.remarks}}" (ngModelChange)="btnEvent($event)"
                                                            matTooltip="{{row.remarks}}" matTooltipPosition="below">

                                                    </mat-form-field>
                                                </td>
                                            </ng-container>

                                            <!-- ============ Customer Ref No. Column ============ -->
                                            <ng-container matColumnDef="amount">
                                                <th mat-header-cell *matHeaderCellDef> Amount
                                                </th>
                                                <td mat-cell *matCellDef="let row;let i=index">
                                                    <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                        <input type="number" matInput name="{{row.sumPaid}}"
                                                            [disabled]="this.getFormDisable" [(ngModel)]="row.sumPaid"
                                                            value="{{row.sumPaid}}"
                                                            (ngModelChange)="btnEvent($event);onchangeSumPaid(i);"
                                                            matTooltip="{{row.sumPaid}}" matTooltipPosition="below">

                                                    </mat-form-field>
                                                </td>
                                            </ng-container>

                                            <!-- ============ Document Date Column ============ -->
                                            <ng-container matColumnDef="location">
                                                <th mat-header-cell *matHeaderCellDef> Location </th>
                                                <td mat-cell *matCellDef="let row">
                                                    <mat-form-field class="full-width" appearance="outline">
                                                        <input type="text" matInput readonly name="location" readonly
                                                            (click)="onOpenDropDown('location',0)"
                                                            [(ngModel)]="row.locationName"
                                                            (ngModelChange)="btnEvent($event)"
                                                            [disabled]="this.getFormDisable" maxlength="254">
                                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                                            (click)="onOpenDropDown('location',0)"
                                                            [class.disabled-icon]="getFormDisable">
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>

                                            <!-- ============ Due Date Column ============ -->
                                            <ng-container matColumnDef="branchName">
                                                <th mat-header-cell *matHeaderCellDef>Branch Name</th>
                                                <td mat-cell *matCellDef="let row">
                                                    <mat-form-field class="full-width" appearance="outline">
                                                        <input type="text" matInput readonly name="branch" readonly
                                                            [(ngModel)]="this.getEntryFormDataSource.branchName"
                                                            (ngModelChange)="btnEvent($event)"
                                                            [disabled]="this.getFormDisable" maxlength="254">
                                                        <!-- <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"> -->
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="deleteRow">
                                                <th mat-header-cell *matHeaderCellDef> {{'Language.ActionText' |
                                                    translate
                                                    }}</th>
                                                <td mat-cell *matCellDef="let element ; let i=index">
                                                    <i-feather *ngIf="this.getFormMode==0 && canAdd"
                                                        class="t-icon popinter pointer" name="trash-2"
                                                        (click)="deleteRow2(i)"> </i-feather>
                                                </td>
                                            </ng-container>


                                            <tr mat-header-row *matHeaderRowDef="displayedColumns2,sticky: true"></tr>
                                            <tr mat-row class="tablecard"
                                                *matRowDef="let row; columns: displayedColumns2;">
                                            </tr>
                                        </table>
                                    </div>


                                </div>
                            </div>
                            <div class="col-md-12 mt-3" *ngIf="this.getFormMode==0 && canAdd">
                                <button mat-stroked-button color="primary"
                                    (click)="addRow2()">{{'Language.AddNewItemText' |
                                    translate }}</button>
                            </div>

                        </div>



                    </mat-tab>



                    <!-- <mat-tab label="{{'Language.AttachmentText' | translate }}">
                 <h2 class="heading8">
                  {{'Language.AttachmentText' | translate }}
                </h2> -->
                    <!--      <div class="page-content">
                    <div class="entry-forms">
                        <div class="col-md-12 mt-3">
                             <label class="f-label full-width">{{'Language.AttachmentsText' | translate
                          }}</label> -->
                    <!-- <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()" (ngModelChange)="btnEvent($event)">
                          <i-feather class="t-icon" name="upload"> </i-feather>
                          {{'Language.UploadFilesText' | translate }}
                      </button>
                      <input type="file" class="file-upload" (change)="onSelectedFiles($event)" multiple (ngModelChange)="btnEvent($event)"> -->
                    <!--     <ng-container
                                *ngIf="this.getEntryFormDataSource.Attachments2_Lines.length > 0; else chooseFiles;">
                                <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()">
                                    <i-feather class="t-icon" name="upload"> </i-feather>
                                    {{'Language.UploadFilesText' | translate }}
                                </button>
                            </ng-container>
                            <ng-template #chooseFiles>
                                <button mat-raised-button class="uploadbtn" color="primary" (click)="input.click()">
                                    <i-feather class="t-icon" name="upload"> </i-feather>
                                    {{'Language.ChooseFilesText' | translate }}
                                </button>
                            </ng-template>
                            <input type="file" class="file-upload d-none" #input (change)="onSelectedFiles($event)"
                                multiple>

                            <span class="field-hint d-block">{{'Language.Youcanuploadamaximumof10files,5MBeachText'
                                | translate }}</span>
                        </div>
                        <div class="col-md-12 mt-4">
                            <div class="carddesign">
                                <div class="row px-3" *ngIf="this.getEntryFormDataSource.Attachments2_Lines.length > 0">
                                    <label class="col-md-2 f-label">{{'Language.ThumbnailText' | translate
                                        }}</label>
                                    <label class="col-md-6 f-label">{{'Language.FileNameText' | translate
                                        }}</label>
                                    <label class="col-md-2 f-label">{{'Language.FileTypeText' | translate
                                        }}</label>
                                    <label class="col-md-2 f-label">{{'Language.DeleteText' | translate
                                        }}</label>
                                </div>
                                <mat-card class="add-detail-files mb-2"
                                    *ngFor="let item of this.getEntryFormDataSource.Attachments2_Lines;let i = index">
                                    <mat-card-content class="py-2">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <i-feather class="" name="image"></i-feather>
                                            </div>
                                            <div class="col-md-6">{{item.FileName}}</div>
                                            <div class="col-md-2">{{item.FileExtension}}</div>
                                            <div class="col-md-2">
                                                <i-feather class="t-icon pointer" name="trash-2"
                                                    (click)="onAttachmentDelete(i)"></i-feather>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div> -->
                    <!-- </mat-card-content>
              </mat-card> -->
                    <!-- </mat-tab> -->




                </mat-tab-group>

            </mat-card-content></mat-card>


        <mat-card class="mt-4">
            <mat-card-content>

                <div class="entry-forms w-55" style="padding-bottom: 50px;">
                    <div class="col-md-12 mt-3">
                        <label class="f-label full-width">{{'Language.AttachmentsText' | translate
                            }}</label>

                        <!-- <input type="file" class="file-upload" (change)="onSelectedFiles($event)" multiple> -->
                        <button mat-raised-button class="uploadbtn" color="primary" (click)="input.click()"
                            [disabled]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'">
                            <i-feather class="t-icon" name="upload"> </i-feather>
                            {{'Language.ChooseFilesText' | translate }}
                        </button>
                        <input type="file" class="file-upload d-none" #input (change)="onSelectedFiles($event)" multiple
                            [disabled]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'">
                        <span class="field-hint d-block">{{'Language.Youcanuploadamaximumof10files,5MBeachText'
                            | translate }}</span>
                    </div>
                    <div class="col-md-7 mt-4">
                        <div class="carddesign">
                            <table class="table table-striped" *ngIf="this.getEntryFormDataSource.Attachments2_Lines 
                                    && this.getEntryFormDataSource.Attachments2_Lines.length > 0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{'Language.ThumbnailText' | translate}}</th>
                                        <th scope="col" width="25%">{{'Language.FileNameText' | translate}}</th>
                                        <th scope="col">{{'Language.FileTypeText' | translate}}</th>
                                        <th scope="col">View</th>
                                        <th scope="col">{{'Language.DeleteText' | translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let item of this.getEntryFormDataSource.Attachments2_Lines;let i = index">
                                        <th scope="row"><i-feather class="" name="image"></i-feather></th>
                                        <td>{{item.FileName}}</td>
                                        <td>{{item.FileExtension}}</td>
                                        <td>
                                            <mat-icon class="pointer" [ngClass]="{'disabled': !item.AbsoluteEntry}"
                                                (click)="viewImage(item.AbsoluteEntry)">
                                                remove_red_eye
                                            </mat-icon>
                                        </td>
                                        <td>
                                            <i-feather class="t-icon pointer" name="trash-2"
                                                (click)="onAttachmentDelete(i)"
                                                [class.disabled-icon]="this.navFrom == 'PendingApproval' || this.navFrom == 'PendingApprovalBulk'">
                                            </i-feather>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-7 mt-3">
                        <ng-container *ngIf="this.selectedFile.length > 0">
                            <div class="text-end">
                                <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()">
                                    <i-feather class="t-icon" name="upload"> </i-feather>
                                    {{'Language.UploadFilesText' | translate }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

            </mat-card-content>
        </mat-card>
        </fieldset>
    </div>


    <!-- <div class=" mt-2 footer">
        <div class="d-flex">
            <div class="me-auto">
                <button #buttonSave mat-raised-button color="primary" (click)="onSave($event)"
                    *ngIf="selectedTabIndex == 2">
                    {{ btnText | translate}}
                </button>
                <button class="me-2" #buttonCancel mat-raised-button (click)="onClickOfGenericCancelButton($event)">
                    {{'Language.CancelText' | translate}}
                </button>
            </div>
            <div class="">
                <button mat-raised-button color="primary" *ngIf="selectedTabIndex != 0" (click)="navigateTab(-1)">
                    <i-feather class="t-icon" name="chevron-left"> </i-feather>
                    {{'Language.PreviousText' | translate}}
                </button>
                <button mat-raised-button color="primary" class="ms-2" *ngIf="selectedTabIndex != 2"
                    (click)="navigateTab(1)">
                    {{'Language.NextText' | translate}}<i-feather class="t-icon" name="chevron-right">
                    </i-feather>
                </button>
            </div>
        </div>
    </div> -->


    <div class="mt-2 footer">
        <div class="row">
            <div class="col-6 d-flex align-items-center">
                <button #buttonSave mat-raised-button color="primary" class="me-1" (click)="onApproveClick($event)"
                    [hidden]="this.navFrom != 'PendingApproval' && this.navFrom != 'PendingApprovalBulk' && this.navFrom != 'originatorPendingReuest'"
                    [disabled]="this.navFrom == 'originatorPendingReuest'"
                    [class.disabled-btn-custom]="this.navFrom == 'originatorPendingReuest'">{{
                    'Language.Approve' | translate}}</button>
                <button class="me-2" #buttonCancel mat-raised-button (click)="onRejectClick($event)"
                    [hidden]="this.navFrom != 'PendingApproval' && this.navFrom != 'PendingApprovalBulk' && this.navFrom != 'originatorPendingReuest'"
                    [disabled]="this.navFrom == 'originatorPendingReuest'"
                    [class.disabled-btn-custom]="this.navFrom == 'originatorPendingReuest'">{{
                    'Language.Reject' | translate}}</button>
                <button #buttonSave mat-raised-button color="primary" class="me-1" (click)="onSave($event)"
                    *ngIf="(getFormMode == 0 && canAdd) || (getFormMode == 1 && canEdit)"
                    [hidden]="this.navFrom=='PendingApproval' || this.navFrom=='PendingApprovalBulk'">{{
                    btnText | translate}}</button>
                <!-- <button mat-raised-button color="primary" class="me-1">{{'Language.PreviewbeforesubmitText' | translate
                    }}</button> -->
                <button class="me-2" #buttonCancel mat-raised-button
                    (click)="onClickOfGenericCancelButton($event)">{{'Language.CancelText' | translate}}</button>
            </div>
            <div class="col-6 text-end d-flex align-items-center justify-content-end">
                <!-- <span class="fs-7 fw-bold me-3">Row Count: ({{rowCount}}) </span> -->
                <span class="fs-8 pe-3">{{'Language.TotalText' | translate}}: </span>

                <span class="fs-6 fw-bold">&#8377; {{this.getEntryFormDataSource.docTotal | number:'0.2'}} </span>
                <button mat-icon-button (click)="openDialog1()" class="ml-2">
                    <mat-icon>payment</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>